export default __webpack_public_path__ + "static/Roobert-Medium-a2f3a644845117dbde5730adea1d0f8d.eot";